<h1>Deal Desk Request</h1>

<div class="container my-4">
    @if (dealDesk) {
    @let dd = dealDesk;

    <!-- Summary -->
    <div class="card mb-3 shadow-sm">
        <div class="card-body">
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-start mb-3">
                <h3 class="card-title mb-1">{{ dd.customerName || 'Unknown Customer' }}</h3>
                <span *ngIf="dd.status" class="badge mt-2 mt-md-0" [ngClass]="statusClass(dd.status)">{{
                    statusLabel(dd.status) }}</span>
            </div>

            <div class="row gx-3 gy-2">
                <div *ngIf="dd.creatorName" class="col-12 col-md-6">
                    <div class="fw-bold">Requested By</div>
                    <span>{{ dd.creatorName }}</span>
                    <span *ngIf="dd.creatorEmail"> &lt;{{ dd.creatorEmail }}&gt;</span>
                </div>

                <div *ngIf="dd.procurementStage" class="col-12 col-md-6">
                    <div class="fw-bold">Procurement Stage</div>
                    <span>{{ dd.procurementStage }}</span>
                </div>

                <div *ngIf="dd.createdAt" class="col-12 col-md-6">
                    <div class="fw-bold">Submitted</div>
                    <span>{{ dd.createdAt | utcToLocal }}</span>
                </div>

                <div *ngIf="dd.updatedAt" class="col-12 col-md-6">
                    <div class="fw-bold">Last Updated</div>
                    <span>{{ dd.updatedAt | utcToLocal }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Customer -->
    <div class="card mb-3 shadow-sm">
        <div class="card-body">
            <h4 class="text-primary">Customer</h4>

            <div class="row gx-3 gy-2">
                <div class="col-12 col-md-6">
                    <div class="fw-bold">Name</div>
                    <span>{{ dd.customerName || '-' }}</span>
                </div>

                <div class="col-12 col-md-6">
                    <div class="fw-bold">Telephone</div>
                    <span>{{ dd.customerTelephone || '-' }}</span>
                </div>

                <div class="col-12 col-md-6">
                    <div class="fw-bold">Address</div>
                    <span class="text-pre">{{ dd.customerAddress || '-' }}</span>
                </div>

                <div class="col-12 col-md-6">
                    <div class="fw-bold">Decision Maker POC</div>
                    <span>{{ dd.decisionMakerPOC || '-' }}</span>
                </div>

                <div class="col-12 col-md-6">
                    <div class="fw-bold">Last Decision Maker Contact</div>
                    <span>{{ (dd.lastDecisionMakerContact | date:'mediumDate':'UTC') || '-' }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Opportunity -->
    <div class="card mb-3 shadow-sm">
        <div class="card-body">
            <h4 class="text-primary">Opportunity</h4>

            <div class="mb-3">
                <div class="fw-bold">Current Opportunity</div>
                <p class="mb-0 text-pre">{{ dd.currentOpportunityDescription || '-' }}</p>
            </div>

            <div>
                <div class="fw-bold">Competitive Situation</div>
                <p class="mb-0 text-pre">{{ dd.competitiveSituationDescription || '-' }}</p>
            </div>
        </div>
    </div>

    <!-- Pricing -->
    <div class="card mb-3 shadow-sm">
        <div class="card-body">
            <h4 class="text-primary">Pricing</h4>

            <div class="row gx-3 gy-2">
                <div class="col-12 col-md-6">
                    <div class="fw-bold">Price Type</div>
                    <span class="text-capitalize">{{ dd.priceType || '-' }}</span>
                </div>

                <div class="col-12 col-md-6">
                    <div class="fw-bold">Discount Requested</div>
                    <span>{{ dd.discountRequested != null ? dd.discountRequested + '%' : '-' }}</span>
                </div>

                <div class="col-12 col-md-6">
                    <div class="fw-bold">Approved Discount</div>
                    <span>{{ dd.approvedDiscount != null ? dd.approvedDiscount + '%' : '-' }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Review -->
    <div class="card mb-3 shadow-sm">
        <div class="card-body">
            <h4 class="text-primary">Review</h4>

            <div class="fw-bold">Review Note</div>
            <p class="mb-0 text-pre">{{ dd.reviewNote || 'This request has not been reviewed yet.' }}</p>
        </div>
    </div>

    <a class="btn btn-secondary" [routerLink]="['/', 'deal-desk']">Back to Deal Desk</a>
    }
    @else if (loadFailed) {
    <div class="alert alert-danger">
        This deal desk request could not be loaded. It may not exist, or you may not have permission to view it.
    </div>
    <a class="btn btn-secondary" [routerLink]="['/', 'deal-desk']">Back to Deal Desk</a>
    }
    @else {
    <app-loading></app-loading>
    }
</div>